import React, { useState, useEffect } from 'react'
import Badge from '@mui/material/Badge';
import Stack from '@mui/material/Stack';
import PropTypes from 'prop-types';
import * as actionTypes from '../../../store/actions';
// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, Button, ButtonBase, IconButton, ListItem, Modal, TextField, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import SchoolIcon from '@mui/icons-material/School';
// project imports
import LogoSection from '../LogoSection';
import SearchSection from './SearchSection';
import LocalizationSection from './LocalizationSection';
import MobileSection from './MobileSection';
import ProfileSection from './ProfileSection';
import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';
import NotificationSection from './NotificationSection';
import EmailIcon from '@mui/icons-material/Email';
import { useLocation, useNavigate } from 'react-router-dom';
import Notice from '../../../caller-components/Notice';
import newInfo from '../../../caller-components/NewInfo';
import { IconMenu2 } from '@tabler/icons';
import NewInfo from '../../../caller-components/NewInfo';
import axios from 'axios';
import { FormattedMessage, useIntl } from 'react-intl';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';



// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle }) => {

    const [isDark, setIsDark] = React.useState(false);
    const theme = useTheme();
    const intl = useIntl();
    const customization = useSelector((state) => state.customization);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const userData = window.location.href.includes('operation') ? null : JSON.parse(localStorage.getItem('userData'));
    const [newInfo, setNewInfo] = useState(false);
    const [notice, setNotice] = useState(false);
    const [noticeObj, setNoticeObj] = useState({});
    const [softModal, setSoftModal] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [appUser, setAppUser] = useState(null);
    const restrictedRoles = ["ortheroanatec", "ortheroanatecadmin","ortheroanatecsecondadmin","ortheroanatecoutsource", "ortheroanateconyx"];
    const paths = ['fullversiontwo', 'analysisversiontwo', 'doctordetail','impressiontwo'];
    const isIframe = window.self !== window.top;
    let pathname = '';
    if (isIframe) {
      try {
        pathname = window.top.location.pathname;
      } catch (e) {
        pathname = window.location.pathname;
      }
    } else {
      pathname = window.location.pathname;
    }      
    const isPathNotIncluded = !paths.some(path => pathname.includes(path));
    const handleDarkMode = () => {
        setIsDark(!isDark)
        !isDark ? dispatch({ type: actionTypes.MENU_TYPE, navType: "dark" }) : dispatch({ type: actionTypes.MENU_TYPE, navType: "light" })
    }

    // const getNotice = async () => {
    //     if (!restrictedRoles.includes(JSON.parse(localStorage.getItem('userData')).role)) {
    //         try {
    //           const response = await axios.post(
    //             `/api2/v2/popup/`
    //           );
    //          setNoticeObj(response.data);
    //          if(localStorage.hasOwnProperty('userData')){
    //             if (JSON.parse(localStorage.getItem('userData')).country === response.data[0].country && response.data[1]) {
    //                 setTimeout(() => setNotice(true),250)
    //             }
    //         }
    //         } catch (err) {
    //           console.log(err);
    //           // navigate('/error-page');
    //         }
    //     }
    // };
    

    const readNotice = async () => {
        try {
            const response = await axios.post(`/api2/v2/addPopup/`, { "id": noticeObj[0].id });
            sessionStorage.setItem("popupState", "true");
            setNotice(false);
            checkSoftSmileModal()
        } catch (err) {
            console.log(err);
            // navigate('/error-page');
        }
    };

    const checkSoftSmileVersion = (version) => {
        const ua = navigator.userAgent.toLowerCase();
        const mac = ua.includes("mac");

        const currentVersion = mac ? "1.16.5" : "1.16.5" ;
        
        const modalShownForVersion = localStorage.getItem("softModalShownForVersion");
        const userCountry = JSON.parse(localStorage.getItem("userData"))?.country;
        const countryAllowed = userCountry !== "88" && userCountry !== "147";

        if ((version !== currentVersion) && (modalShownForVersion !== currentVersion) && countryAllowed) {
            setSoftModal(true);
        }
    }

   
    const checkSoftSmileModal = () => {
        if (isPathNotIncluded) {
            //getNotice();
            const user = JSON.parse(localStorage.getItem("userData"));
            if (user?.softsmile_show_download_link && window.innerWidth > 768) {
                checkSoftSmileVersion(localStorage.getItem("softSmileVersion"));
            }
        }
    }

    const getSoftSmileDownloadLink = () => {
        
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const ua = userAgent.toLowerCase();
        if (ua.includes("win")) {
            return "https://dr.orthero.com.tr/static/1.16.5-ORT-DFA.exe";
        }
        if (ua.includes("mac")) {
            return "https://dr.orthero.com.tr/static/1.16.5-ORT-MAC-DFA.pkg";
        }
        if (ua.includes("safari") && !ua.includes("chrome")) {
            return "https://dr.orthero.com.tr/static/1.16.5-ORT-MAC-DFA.pkg";
        }
        return "https://dr.orthero.com.tr/static/1.16.5-ORT-DFA.exe";
    };

    const saveSoftSmileVersion = async () => {
        const currentVersion = "1.16.5";
        const getVersion = localStorage.getItem("softSmileVersion");
        const checkVersion = getVersion ? getVersion === currentVersion : false;
        if (!checkVersion) {
            try {
                const requestData = {
                    softsmile_version_data: {
                        [currentVersion]: { download: true }
                    }
                };
                await axios.post(`/api2/v2/doctors/softsmile/download/`, requestData);
                localStorage.setItem("softSmileVersion", currentVersion);
            } catch (error) {
                console.log("catch", error);
            }
        }
    };

    const handleSoftSmileDownload = () => {
        saveSoftSmileVersion();
        const link = document.createElement('a');
        link.href = getSoftSmileDownloadLink();
        link.setAttribute('download', '');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const closeSoftModal = () => {
        setSoftModal(false);
        localStorage.setItem("softModalShownForVersion", "1.16.5");
    };

    useEffect(() => {
        const raw = localStorage.getItem("userData");
        if (raw) {
            setAppUser(JSON.parse(raw));
        }
        // if (isPathNotIncluded) {
        //     //getNotice();
        //     const user = JSON.parse(localStorage.getItem("userData"));
        //     if (user?.softsmile_show_download_link && window.innerWidth > 768) {
        //         checkSoftSmileVersion(localStorage.getItem("softSmileVersion"));
        //     }
        // }
    }, [])

    useEffect(() => {
    setSearchValue('');
    }, [location.pathname]);

     useEffect(() => {

        const fetchNotice = async () => {
            if (!appUser || restrictedRoles.includes(appUser.role) || !isPathNotIncluded) return;
            if (sessionStorage.getItem("popupState") === "true") return;
            try {
                const response = await axios.post("/api2/v2/popup/");
                setNoticeObj(response.data);
                if (appUser.country === response.data[0]?.country && response.data[1]) {
                    setTimeout(() => setNotice(true), 250);
                }else{
                    checkSoftSmileModal();
                }
            } catch (err) {
                console.error("getNotice error:", err);
            }
        };

        fetchNotice();
    }, [appUser])
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
          navigate(`/search-cases?search=${encodeURIComponent(searchValue)}`);
        }
    };
    
    const handleChange = (e) => {
        setSearchValue(e.target.value);
    };

    const style = {
        position: "absolute",
        top: "25%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 700,
        bgcolor: "background.paper",
        outline: "none",
        boxShadow: 24,
        p: 4,
        borderRadius: 2
    }
    
    return (
        <>
            {!window.location.href.includes('operation') &&
                <>
                    <NewInfo newInfo={newInfo} setNewInfo={setNewInfo} />
                    {notice && <Notice readNotice = {readNotice} noticeObj = {noticeObj} notice={notice} setNotice={setNotice} checkSoftSmileModal={checkSoftSmileModal}/> }
                    <Box
                        sx={{
                            width: 228,
                            display: 'flex',
                            [theme.breakpoints.down('md')]: {
                                width: 'auto'
                            }
                        }}
                    >
                        <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                            <LogoSection />
                        </Box>
                        <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
                            <Avatar
                                variant="rounded"
                                sx={{
                                    ...theme.typography.commonAvatar,
                                    ...theme.typography.mediumAvatar,
                                    transition: 'all .2s ease-in-out',
                                    background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.secondary.light,
                                    color: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
                                    '&:hover': {
                                        background: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
                                        color: theme.palette.mode === 'dark' ? theme.palette.secondary.light : theme.palette.secondary.light
                                    }
                                }}
                                onClick={handleLeftDrawerToggle}
                                color="inherit"
                            >
                                <IconMenu2 stroke={1.5} size="1.3rem" />
                            </Avatar>
                        </ButtonBase>
                    </Box>

                    {/* header search */}
                    {/* <SearchSection /> */}
                    {userData && userData?.role === "doctor"
                        ?<Box 
                            sx={{ 
                                flexGrow: 1,
                                '& .MuiFormControl-root': {
                                    width:"40%",
                                    '@media (max-width:600px)': {
                                        width:"auto",
                                        maxWidth:"75%"
                                    },
                                }, 
                            }}
                        >
                                <ListItem
                                    sx={{
                                        p: 0,
                                        '&:hover': { backgroundColor: 'transparent' },
                                        marginLeft: 6,
                                        '@media (max-width:600px)': {
                                            marginLeft: 3
                                        },
                                        
                                    }}
                                >
                                <TextField
                                    size="small"
                                    value={searchValue}
                                    onChange={handleChange}
                                    placeholder={intl.formatMessage({id:"Search and press Enter",defaultMessage:"Search and press Enter"})}
                                    onKeyPress={handleKeyPress}
                                    InputProps={{
                                    startAdornment: <SearchIcon sx={{ mr: 1, color: 'action.active' }} />,
                                    sx: {
                                        cursor: 'text',
                                        backgroundColor: 'background.paper',
                                        '&:hover': {
                                        backgroundColor: 'action.hover'
                                        },
                                        }
                                    }}
                                />
                                </ListItem>
                            </Box>
                        :<>
                            <Box sx={{ flexGrow: 1 }} />
                        </>  
                    }
                    <Box sx={{ display: { xs: 'none', sm: 'block' } }}></Box>

                    {/* <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                        <button onClick={handleDarkMode}>dark mode</button>
                    </Box> */}
                    {/* live customization & localization */}
                    <Box mr={2} sx={{ display: { xs: 'none', sm: 'block' } }}>
                        <LocalizationSection />
                    </Box>

                    {/* notification & profile */}
                    {/* <NotificationSection />
            <NotificationSection /> */}
                    <Box display="flex" gap="0.5rem" mr={2}>
                        <Stack spacing={2} direction="row">
                            {['ortheroanatecadmin', 'ortheroanatecoutsource', 'ortheroanatecsecondadmin', 'ortheroanatec', 'ortheroanateconyx'].includes(userData?.role) ? (
                                <>
                                    {(userData?.role !== 'ortheroanatecoutsource' || userData?.role !== 'ortheroanateconyx') && (
                                        <Badge onClick={() => setNewInfo(true)} style={{ cursor: 'pointer' }} color="secondary">
                                            <SchoolIcon style={{ fontSize: "26px" }} color="action" />
                                        </Badge>
                                    )}
                                    <Badge onClick={() => navigate('/anatec-notifications')} style={{ cursor: 'pointer' }} badgeContent={JSON.parse(localStorage.getItem('userData'))?.doctor_come_len_of_notes} color="secondary">
                                        <CircleNotificationsIcon style={{ fontSize: "26px" }} color="action" />
                                    </Badge>
                                    <Badge onClick={() => navigate('/anatec-messages')} style={{ cursor: 'pointer' }} badgeContent={JSON.parse(localStorage.getItem('userData'))?.len_of_notes} color="secondary">
                                        <EmailIcon style={{ fontSize: "26px" }} color="action" />
                                    </Badge>
                                </>
                            ) : (
                                <>
                                    <Badge onClick={() => setNewInfo(true)} style={{ cursor: 'pointer' }} color="secondary">
                                        <SchoolIcon style={{ fontSize: "26px" }} color="action" />
                                    </Badge>
                                    <Badge onClick={() => navigate('/notifications')} style={{ cursor: 'pointer' }} badgeContent={JSON.parse(localStorage.getItem('userData'))?.len_of_notifications} color="secondary">
                                        <CircleNotificationsIcon style={{ fontSize: "26px" }} color="action" />
                                    </Badge>
                                    <Badge onClick={() => navigate('/messages')} style={{ cursor: 'pointer' }} badgeContent={JSON.parse(localStorage.getItem('userData'))?.len_of_notes} color="secondary">
                                        <EmailIcon style={{ fontSize: "26px" }} color="action" />
                                    </Badge>
                                </>
                            )}
                        </Stack>
                    </Box>
                    <ProfileSection />

                    {/* mobile header */}
                    <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                        <MobileSection />
                    </Box>
                    <Modal
                        open={softModal}
                        onClose={closeSoftModal}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={style}>
                            <IconButton
                                onClick={closeSoftModal}
                                sx={{ position: 'absolute', top: 8, right: 8, color: '#663BB9' }}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            <Typography textAlign="left" fontSize="18px" color="#663BB9" marginBottom={1}>
                                <FormattedMessage id={"softModal.dearDoctor"} defaultMessage={"Dear Doctor"} />,
                            </Typography>
                            <Typography textAlign="left" fontSize="20px" fontWeight={600} color="#663BB9" marginBottom={2}>
                                <FormattedMessage id={"softModal.versionReleased"} />
                            </Typography>
                            <Typography textAlign="left" fontSize="18px" color="#663BB9" marginBottom={2}>
                                <FormattedMessage id={"softModal.outdatedBody"} />
                            </Typography>
                            <Typography textAlign="left" fontSize="18px" color="#663BB9" marginBottom={2}>
                                <FormattedMessage id={"softModal.downloadInfo"} />
                            </Typography>
                            <Typography textAlign="left" fontSize="18px" color="#663BB9" marginBottom={2}>
                                <FormattedMessage id={"softModal.bestRegards"} defaultMessage={"Best regards."} />
                            </Typography>
                            <Box textAlign={"center"} marginTop={2}>
                                <Button
                                    style={{ color: "#f2f4f6", fontWeight: "500", margin: "auto" }}
                                    variant="contained"
                                    onClick={() => {
                                        handleSoftSmileDownload();
                                        closeSoftModal();
                                    }}
                                >
                                    <FormattedMessage id={"softModal.downloadNow"} defaultMessage={"Download Latest Version Now"} />
                                </Button>
                            </Box>
                        </Box>
                    </Modal>
                </>
            }
        </>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default Header;
